import {Box, Button, Stack, Typography} from '@mui/material'
import {FC, ReactNode} from 'react'
import {useNavigate} from 'react-router-dom'

interface ResultLayoutProps {
    heading: string
    formValue: string
    resultComponent: ReactNode
    searchType: "smallBusiness" | "federal" | "privateFoundations"
}


export const ResultLayout: FC<ResultLayoutProps> = ({heading, searchType, resultComponent}) => {
    const navigate = useNavigate()

    const handleViewAll = (searchType: string) => {
        navigate(`/browse/${searchType}`)
    }

    return (
        <Box mt={4}>
            <Stack mb={2} direction="row" alignItems="center" justifyContent="space-between">
                <Typography color="seondary" fontWeight={600} fontSize="1rem">
                    {heading}
                </Typography>

                <Button
                    key={searchType}
                    color="secondary"
                    variant="outlined"
                    disableElevation={true}
                    sx={{
                        fontSize: '0.875rem',
                        background: 'white',
                        borderRadius: '8px',
                        textTransform: 'none',
                    }}
                    onClick={() => handleViewAll(searchType)}
                >
                    View all
                </Button>
            </Stack>

            {resultComponent}
        </Box>
    )
}
